
import $ from 'jquery';

$(function () {
  $('body').on('mouseenter', '.mm_tabs_li.mm_tabs_has_content', function () {
    var $this = $(this);
    var $contents = $this.find('.mm_columns_contents_ul');
    var $allTabs = $this.closest('.mm_columns_ul').find('.mm_tabs_li');

    // 1. Hauteur du contenu actif
    if ($contents.length) {
      var height = $contents.outerHeight();

      // 2. Somme des hauteurs de tous les onglets (y compris celui-ci)
      var totalHeight = 0;
      $allTabs.each(function () {
        totalHeight += $(this).outerHeight();
      });

      // 3. Trouver le conteneur cible pour appliquer les variables
      var $megaMenu = $('.ets_mm_megamenu .mm_columns_ul').has('.mm_tabs_li.mm_tabs_has_content.open');

      if ($megaMenu.length) {
        $megaMenu.css('--mm-after-height', height + 'px');
        $megaMenu.css('--mm-after-min-height', totalHeight + 'px');
      }
    }
  });
});
